import ApiClient from './ApiClient';

// The upstream changelog lives on the Chatwoot hub. This build is offline, so
// the sidebar card gets an empty feed instead of an outbound request.
class ChangelogApi extends ApiClient {
  constructor() {
    super('changelog', { apiVersion: 'v1' });
  }

  // eslint-disable-next-line class-methods-use-this
  fetchFromHub() {
    return Promise.resolve({ data: [] });
  }
}

export default new ChangelogApi();
